
export const LOCALES = {
    SERBIAN: 'rs-RS',
    ENGLISH: 'en-US',
    RUSSIAN: 'ru-RU'

}
